(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_gift-guide-chapter"] && !Shopify.designMode) return;
  try {
    (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const isPaused = (video) => video.dataset.a11yAutoplayPaused === 'true';
    const play = (video) => {
      video.muted = true;
      const playing = video.play();
      if (playing && playing.catch) playing.catch(() => {});
    };
    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            video.dataset.giftGuideInView = entry.isIntersecting ? 'true' : 'false';
            if (entry.isIntersecting && !isPaused(video)) {
              play(video);
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.2 })
      : null;
    const showPoster = (video) => {
      if (video.dataset.poster && !video.getAttribute('poster')) video.setAttribute('poster', video.dataset.poster);
    };
    const posterObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            showPoster(entry.target);
            posterObserver.unobserve(entry.target);
          });
        }, { rootMargin: '150% 0px' })
      : null;

    const addToggle = (video) => {
      const figure = video.closest('figure');
      if (!figure) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'a11y-autoplay-toggle play-pause-toggle play-pause-toggle--bare play-pause-toggle--media a11y-autoplay-toggle--media-corner';
      button.setAttribute('data-click-name', 'Video - Autoplay');
      const sync = () => {
        const paused = isPaused(video);
        button.setAttribute('data-paused', paused ? 'true' : 'false');
        button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      };
      button.addEventListener('click', () => {
        video.dataset.a11yAutoplayPaused = isPaused(video) ? 'false' : 'true';
        if (isPaused(video)) {
          video.pause();
        } else if (!observer || video.dataset.giftGuideInView === 'true') {
          play(video);
        }
        sync();
      });
      figure.classList.add('a11y-autoplay-container');
      figure.append(button);
      sync();
    };

    const init = (root) => {
      root.querySelectorAll('.gift-guide-chapter_video:not([data-gift-guide-video])').forEach((video) => {
        video.setAttribute('data-gift-guide-video', '');
        video.dataset.a11yAutoplayPaused = reducedMotion.matches ? 'true' : 'false';
        video.muted = true;
        addToggle(video);
        if (posterObserver) {
          posterObserver.observe(video);
        } else {
          showPoster(video);
        }
        if (observer) {
          observer.observe(video);
        } else if (!isPaused(video)) {
          play(video);
        }
      });
    };

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
